module.exports = __webpack_public_path__ + "static/media/20.58c7fb27.png";